//Этот компонент выводит карточку с информацией о необходимых документах и возможностью загрузить или скачать их!
//С левой стороны карточки выводится вся необходимая информация о доках, с правой стороны - кнопка для вышеописанных целей!
//Есть возможность передавать свои стили, либо будут применены стили по-дефолту

import { Tag } from "antd";
import React, { FC } from "react";
import { UI_ModuleTitleCardProps } from "../../interfaces/props/UI_ModuleTitleCardProps";

import classes from "./style/UI_ITOModuleDocuments.module.css";

export const UI_ModuleDocuments: FC<UI_ModuleTitleCardProps> = (props) => {
  const { title, style, icon, titleDown, tag } = props;

  return (
    <div className={classes.card} style={style}>
      <div className={classes.titleWrapper}>
        <div className={classes.title}>{title}</div>
        {titleDown}
      </div>

      <div className={classes.iconWrapper}>
        {titleDown !== "Документ не загружен" && tag && (
          <Tag color={tag.color}>{tag.title}</Tag>
        )}
        {icon}
      </div>
    </div>
  );
};
